import { SET_CLOUD_ACCOUNTS, SELECT_CLOUD_ACCOUNT, SELECT_PROVIDER } from '@constants/ActionTypes';

const INIT_STATE = {
  accounts: [],
  selectedAccounts: null,
  provider: 'AWS'
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_CLOUD_ACCOUNTS: {
      return {
        ...state,
        accounts: action.payload
      };
    }
    case SELECT_CLOUD_ACCOUNT: {
      return {
        ...state,
        selectedAccounts: action.payload
      };
    }
    case SELECT_PROVIDER: {
      return {
        ...state,
        provider: action.payload
      };
    }
    default:
      return state;
  }
};
